import { useState } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  ebookId: string;
  onSuccess?: () => void;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function EmailGateModal({ open, onOpenChange, ebookId, onSuccess }: Props) {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!EMAIL_RE.test(trimmed)) {
      toast.error('กรุณากรอกอีเมลให้ถูกต้อง');
      return;
    }
    setSubmitting(true);
    try {
      const { data, error } = await supabase.functions.invoke('ebook-download', {
        body: { ebook_id: ebookId, email: trimmed },
      });
      if (error || !data?.signedUrl) throw error ?? new Error('no signed url');

      window.open(data.signedUrl, '_blank', 'noopener,noreferrer');
      toast.success('ส่ง PDF ให้แล้ว เปิดในแท็บใหม่');
      onSuccess?.();
      onOpenChange(false);
      setEmail('');
    } catch (err) {
      console.error('EmailGateModal error:', err);
      toast.error('เปิด PDF ไม่สำเร็จ ลองใหม่อีกครั้ง');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        style={{
          background: 'linear-gradient(145deg, #012840 0%, #0A1A26 100%)',
          border: '1px solid rgba(5, 242, 242, 0.2)',
          color: '#F0F8FF',
        }}
      >
        <DialogHeader>
          <DialogTitle style={{ color: '#F0F8FF' }}>กรอกอีเมลเพื่อรับ PDF ฟรี</DialogTitle>
          <DialogDescription style={{ color: '#6593A6' }}>
            เราจะเปิด PDF ให้ในแท็บใหม่ทันที
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} noValidate className="flex flex-col gap-3 mt-2">
          <input
            type="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="email@example.com"
            style={{
              background: 'rgba(101,147,166,0.08)',
              border: '1px solid rgba(101,147,166,0.2)',
              color: '#F0F8FF',
              borderRadius: 8,
              padding: '12px 14px',
              fontSize: 14,
              outline: 'none',
              minHeight: 44,
            }}
          />
          <button
            type="submit"
            disabled={submitting}
            className="font-medium hover:brightness-110 disabled:opacity-60"
            style={{
              background: 'linear-gradient(135deg, #F27405, #D45E00)',
              color: '#fff',
              borderRadius: 8,
              padding: '12px 16px',
              fontSize: 14,
              minHeight: 44,
              boxShadow: '0 0 16px rgba(242,116,5,0.2)',
            }}
          >
            {submitting ? 'กำลังส่ง…' : 'รับเลย'}
          </button>
          <div className="text-[11px] text-center" style={{ color: '#3D6D82' }}>
            ไม่ spam — ใช้ส่งอัปเดตเล่มใหม่เท่านั้น
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
